// src/composables/getPetAd.js
import { ref } from 'vue';
import { getPetListingById, getAllPets } from '@/services/petService';

// Tek bir pet için
export const useGetPetAd = (petId) => {
  const petAd = ref(null);
  const error = ref(null);
  const loading = ref(false);

  const fetchPetAd = async () => {
    loading.value = true;
    try {
      const docSnap = await getPetListingById(petId);
      
      if (docSnap.exists()) {
        petAd.value = { id: docSnap.id, ...docSnap.data() };
      } else {
        error.value = 'İlan bulunamadı';
      }
    } catch (err) {
      error.value = err.message;
    } finally {
      loading.value = false;
    }
  };

  return { petAd, error, loading, fetchPetAd };
};

// Tüm petler için
export const useGetPetAds = () => {
  const petAds = ref([]);
  const error = ref(null);
  const loading = ref(false);

  const fetchPetAds = async () => {
    loading.value = true;
    try {
      const querySnapshot = await getAllPets();
      petAds.value = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    } catch (err) {
      error.value = err.message;
    } finally {
      loading.value = false;
    }
  };

  return { petAds, error, loading, fetchPetAds };
};